import { RankedMetric, RankingHeader, RankingRequest } from '@features/rankings/models/ranking.model'
import { parseCommonRankingRow } from '@features/rankings/utils/ranking-common.utils'
import { PLACEHOLDER_IMAGES } from '@mediacoach/ui'
import { ComparableMetric, ListedMetric } from '@core/models/metric.models'
import { Player, PlayerHolder, PlayerSummary } from '@core/models/player.models'
import { ContextMenuHolder } from '@core/models/context-menu.models'
import { Aggregation } from '@features/aggregations/models/aggregations.models'

export const parsePlayerToRankingRequest = (
  context: Player,
  value: ListedMetric | ComparableMetric,
  mode: Aggregation
): RankingRequest => ({
  seasonId: context.seasonId,
  competitionId: context.competitionId,
  metricName: value.key,
  players: [{ playerId: context.playerId ?? context.id, teamId: context.teamId }],
  aggregationDataSource: mode
})

export const parsePlayerMatchToRankingRequest = (
  context: Player,
  value: ListedMetric | ComparableMetric,
  mode: Aggregation
): RankingRequest => ({
  ...parsePlayerToRankingRequest(context, value, mode),
  matchId: context.id
})

export const parsePlayerRankingRows = (rankedMetric: RankedMetric[], context: ContextMenuHolder): RankedMetric[] => {
  const selectedValues = (rankedMetric || []).filter((m) => m.isSelected)

  const playerContext = context as PlayerHolder
  const id =
    playerContext?.comparison?.playerA?.id ??
    playerContext?.comparison?.playerA?.playerId ??
    playerContext?.player?.playerId ??
    playerContext?.player?.id

  return (rankedMetric || []).map((m) => {
    const metric = parseCommonRankingRow(m, context)
    return {
      ...metric,
      imagePlaceholder: PLACEHOLDER_IMAGES.PLAYER,
      teamPlaceholder: PLACEHOLDER_IMAGES.TEAM,
      position: metric.isCompetition ? '-' : m.position,
      styleClass: [
        'mcm-ranking__row',
        !metric.isCompetition ? 'avatar' : null,
        m.isSelected ? 'selected' : null,
        m.id === id ? 'home' : null,
        selectedValues.length > 1 && m.id === selectedValues[0].id ? 'first-selected' : null,
        selectedValues.length > 1 && m.id === selectedValues[1].id ? 'last-selected' : null
      ]
        .filter(Boolean)
        .join(' ')
    }
  })
}

export const parsePlayerRankingHeader = (
  metricKey: string,
  metricContext: PlayerSummary,
  matchDay: number
): RankingHeader => ({
  title: metricKey,
  imageA: metricContext.portraitLogo,
  textA: metricContext.metricPlayerName,
  imageAStyleClass: 'mcm-rankings__avatar',
  imageB: metricContext?.competition?.isoTypeLogo,
  textB: metricContext?.competition?.officialName,
  placeholderA: PLACEHOLDER_IMAGES.PLAYER,
  placeholderB: PLACEHOLDER_IMAGES.PLAYER,
  matchDay
})

export const parseMatchPlayerRankingHeader = (
  metricKey: string,
  metricContext: PlayerSummary,
  matchDay: number
): RankingHeader => ({
  title: metricKey,
  imageA: metricContext.portraitLogo,
  textA: metricContext.metricPlayerName,
  imageAStyleClass: 'mcm-rankings__avatar',
  textB: 'MTR_TITLE_MATCH',
  placeholderA: PLACEHOLDER_IMAGES.PLAYER,
  matchDay
})
